@for ( legendInfo of layer.props?.legendInfo; track trackByFn(i, legendInfo);
let i = $index) {
<div class="legend-detail">
  @if (legendInfo?.mapLayerType == 'Boundary') {
  <div class="layer-legend-container">
    <div>
      <span
        class="boundary-legend-icon"
        [style.background-color]="legendInfo.fillColor"
        [style.border-color]="legendInfo.lineColor"
        [style.border-width]="legendInfo.lineWidth + 'px'"
      >
      </span>
    </div>
    @if (isSpotlightSupported) {
    <div
      [class.legend-item-bold]="isSelected(legendInfo.text)"
      (click)="onLegendItemClick(legendInfo.text)"
    >
      <span class="boundary-legend-text legend-text legend-text-spotlight"
        >{{ legendInfo.text }}
      </span>
    </div>
    } @if (!isSpotlightSupported) {
    <div>
      <span class="boundary-legend-text legend-text"
        >{{ legendInfo.text }}
      </span>
    </div>
    }
  </div>
  } @if (legendInfo?.mapLayerType == 'H3Hexagon') {
  <div class="layer-legend-container">
    <div>
      <span
        class="boundary-legend-icon"
        [style.background-color]="legendInfo.fillColor"
        [style.border-color]="legendInfo.lineColor"
        [style.border-width]="legendInfo.lineWidth + 'px'"
      >
      </span>
    </div>
  </div>
  } @if (legendInfo?.mapLayerType == 'Line') {
  <div class="layer-legend-container">
    <div>
      <span
        class="line-legend-icon"
        [style.background-color]="legendInfo.fillColor"
        [style.border-color]="legendInfo.lineColor"
        [style.border-width]="legendInfo.lineWidth + 'px'"
      >
      </span>
    </div>
    @if (isSpotlightSupported) {
    <div
      [class.legend-item-bold]="isSelected(legendInfo.text)"
      (click)="onLegendItemClick(legendInfo.text)"
    >
      <span class="boundary-legend-text legend-text legend-text-spotlight">{{
        legendInfo.text
      }}</span>
    </div>
    } @if (!isSpotlightSupported) {
    <div>
      <span class="boundary-legend-text legend-text"
        >{{ legendInfo.text }}
      </span>
    </div>
    }
  </div>
  } @if (legendInfo?.mapLayerType == 'Point') {
  <div class="layer-legend-container">
    <div>
      <span
        class="point-legend-icon"
        [style.background-color]="legendInfo.fillColor"
        [style.border-color]="legendInfo.lineColor"
      >
      </span>
    </div>
    @if (isSpotlightSupported) {
    <div
      [class.legend-item-bold]="isSelected(legendInfo.text)"
      (click)="onLegendItemClick(legendInfo.text)"
    >
      <span class="point-legend-text legend-text legend-text-spotlight">{{
        legendInfo.text
      }}</span>
    </div>
    } @if (!isSpotlightSupported) {
    <div>
      <span class="point-legend-text legend-text">{{ legendInfo.text }}</span>
    </div>
    }
  </div>
  } @if (layer?.props?.iconSizeAttribute) {
  <div class="layer-legend-container">
    @if(minIconSize !== null && maxIconSize !== null){
    <div class="icon-size-range">
      <div class="icon-size-item">
        <img
          [attr.src]="legendInfo.iconUrl"
          [style.filter]="shouldApplyFilter(legendInfo) ? legendInfo.iconFilter : null"
          [style.width.px]="18"
          [style.height.px]="18"
        />
        <p>{{ minIconSize }}px</p>
      </div>
      <div class="icon-size-item">
        <img
          [attr.src]="legendInfo.iconUrl"
          [style.filter]="shouldApplyFilter(legendInfo) ? legendInfo.iconFilter : null"
          [style.width.px]="32"
          [style.height.px]="32"
        />
        <p>{{ maxIconSize }}px</p>
      </div>
      <div
        class="icon-legend-text legend-text"
        [class.legend-item-bold]="isSelected(legendInfo.text)"
        (click)="onLegendItemClick(legendInfo.text)"
      >
        {{ legendInfo.text }}
      </div>
    </div>
    }
  </div>
  } @if ( !layer?.props?.iconSizeAttribute && (legendInfo?.mapLayerType ==
  'Icon' || legendInfo?.mapLayerType == 'InSiteEverywhereMapPin') ) {
  <div class="layer-legend-container">
    <div>
      <span class="icon-legend-icon">
        <img
          class="icon-size"
          [style.filter]="
            shouldApplyFilter(legendInfo) ? legendInfo.iconFilter : null
          "
          [attr.src]="legendInfo.iconUrl"
          [style.width]="legendInfo.iconWidth"
          [style.height]="legendInfo.iconHeight"
        />
      </span>
    </div>
    @if (isSpotlightSupported) {
    <div
      [class.legend-item-bold]="isSelected(legendInfo.text)"
      (click)="onLegendItemClick(legendInfo.text)"
    >
      <span class="icon-legend-text legend-text legend-text-spotlight">
        {{ legendInfo.text }}
      </span>
    </div>
    } @if (!isSpotlightSupported) {
    <div>
      <span class="icon-legend-text legend-text">{{ legendInfo.text }}</span>
    </div>
    }
  </div>
  } @if (legendInfo?.mapLayerType == 'Label') {
  <div class="layer-legend-container">
    <div>
      <span
        class="boundary-legend-icon"
        [style.background-color]="legendInfo.labelBackground"
        [style.color]="legendInfo.fillColor"
        [style.border-color]="legendInfo.labelBackground"
        [style.border-width]="legendInfo.lineWidth + 'px'"
        style="padding-left: 5px"
      >
        Abc
      </span>
    </div>
    <div>
      <span class="boundary-legend-text legend-text"
        >{{ legendInfo.text }}
      </span>
    </div>
  </div>
  }
</div>
}
